module.exports = __webpack_public_path__ + "img/Two.360bb5fa.jpg";